import Color from 'color'

// main colors
export const blue = '#40B5E8'

export const lightBlue = '#daf3ff'

export const green = '#24D44B'
export const lightGreen = '#D8F5DE'
export const paleGreen = '#D8F4E3'

export const black = '#000000'
export const darkGrey = '#555555'
export const mediumGrey = '#848484'
export const lightGrey = '#E5E5E5'
export const backgroundGrey = '#F9F9F9'
export const bannerGrey = '#F0F0F0'

// secondary colors
export const trafficGreenLight = '#E1F1E5'
export const trafficGreenDark = '#488A55'
export const trafficYellowLight = '#FDF1B6'
export const trafficYellowDark = '#867C4A'
export const trafficRedLight = '#FFD8D8'
export const trafficRedDark = '#DF4949'

// some unique old colors used for single cases/graphs
export const darkBlue = '#266DAE'
export const caribbeanBlue = '#1CC1D8'
export const purple = '#C92F94'
export const lilac = '#9D5DC5'
export const brown = '#DB8E46'
export const orange = '#FFB800'
export const red = '#FF4B55'

export const facebookBlue = '#1778F2'
export const googleBlue = '#3C8BD9'
export const dv360blue = '#40b5e8'
export const instagramOrange = '#FF7944'
export const googleAdsTextBlue = '#1D5BCE'
export const googleAdsTextGrey = '#606060'
export const googleAdsYellow = '#ffc008'

export const transparent = 'rgba(0,0,0,0)'
export const mainBackgroundColor = backgroundGrey

export const trafficRedDarkHover = Color(trafficRedDark).darken(0.2).rgb().string()
